import { type Provider, providers } from "../const";
import { Avatar } from "./avatar";

type Props = {
  provider: Provider;
};

export const Item = ({ provider }: Props) => {
  const { name, type } = providers[provider];

  return (
    <div className="flex items-center gap-4">
      <Avatar
        imgClassName="size-10 md:size-[52px]"
        onlyImage
        provider={provider}
      />

      <div className="flex flex-col">
        <h3 className="text-lg leading-8 font-semibold md:text-2xl">{name}</h3>
        <p className="text-paleSky text-xs leading-5 font-semibold md:text-sm">
          {type}
        </p>
      </div>
    </div>
  );
};
